import axios from "axios";
import { store } from "../redux";
import config from "../config";
import { setToken, logOut } from "../redux/auth";
import { isSimpleObject } from "../helpers";
const baseUrl = config.get("endpoint") + "/api/v1";

class HttpService {
  setHeaderToken(headers) {
    if (!headers) return;
    const { authorization } = headers || {};
    if (authorization) {
      store.dispatch(setToken(authorization));
    }
  }
  getUrl = (url) => {
    return baseUrl + url
  }
  request = async (callback) => {
    try {
      const res = await callback();
      this.setHeaderToken(res.headers);
      // if ((res.data?.status || res.status) === "Unauthorized") {
      //   store.dispatch(logOut());
      // }
      return res.data;
    } catch (error) {
      this.setHeaderToken(error?.response?.headers);
      switch (error?.response?.status) {
        case 401:
          store.dispatch(logOut());
          break;
        default:
          console.log(error);
      }
      return {
        error,
        data: null,
      };
    }
  };
  getBaseURL = () => {
    return baseUrl;
  }
  getToken = () => {
    const { token } = store.getState().auth;
    return token;
  };
  addDefaultConfig = (config = {}) => {
    const { token } = store.getState().auth;
    Object.assign(config, { withCredentials: true });

    if (!token) return config;
    return {
      ...config,
      headers: {
        ...(config?.headers || {}),
        Authorization: `Bearer ${token}`,
      },
    };
  };
  updateProgressBarValue = (formName, progress) => {
    // TODO: connect this
    console.log(`${formName}: ${progress}%`);
  };

  post(url, params = {}, config = {}) {
    return this.request(() =>
      axios.post(baseUrl + url, params, this.addDefaultConfig(config))
    );
  }
  put(url, params = {}, config = {}, formName) {
    return this.request(() =>
      axios.put(baseUrl + url, params, this.addDefaultConfig(config))
    );
  }
  patch(url, params = {}, config = {}, formName) {
    return this.request(() =>
      axios.patch(baseUrl + url, params, this.addDefaultConfig(config))
    );
  }
  get(url, config = {}) {
    return this.request(() =>
      axios.get(baseUrl + url, this.addDefaultConfig(config))
    );
  }
  delete(url, config = {}) {
    return this.request(() =>
      axios.delete(baseUrl + url, this.addDefaultConfig(config))
    );
  }
  form(url, params, formName, config = {}, reqMethod) {
    let formData;
    if (params instanceof FormData) {
      formData = params;
    } else {
      formData = new FormData();
      const append = (key, value) => {
        if (isSimpleObject(value)) {
          append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      };
      for (const [key, value] of Object.entries(params)) {
        append(key, value);
      }
    }
    return this[reqMethod || "post"](url, formData, {
      ...config,
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );
        console.log("onUploadProgress", totalLength);
        if (totalLength !== null) {
          this.updateProgressBarValue(
            formName,
            Math.round((progressEvent.loaded * 100) / totalLength)
          );
        }
      },
    });
  }
}

const httpService = new HttpService();
export default httpService;
